import {
  INFO_LAB_REQUEST,
  INFO_LAB_SUCCESS,
  INFO_LAB_FAIL,
} from "../constants/labInfo_constant";

export const labInfoReducers = (state = { labInfos: {} }, action) => {
  switch (action.type) {
    case INFO_LAB_REQUEST:
      return { loading: true };
    case INFO_LAB_SUCCESS:
      return { loading: false, labInfos: action.payload };
    case INFO_LAB_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};
